import { render, staticRenderFns } from "./BoxSelectPreview.vue?vue&type=template&id=3de92bdb&scoped=true"
import script from "./BoxSelectPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoxSelectPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BoxSelectPreview.vue?vue&type=style&index=0&id=3de92bdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de92bdb",
  null
  
)

export default component.exports